import { IntegrationsStatusEnum } from 'types/integrations';
import useUserPeppolIntegration from './useUserPeppolIntegration';

const usePeppolNudge = () => {
  const { data } = useUserPeppolIntegration();

  return data?.status === IntegrationsStatusEnum.verification_required;
};

export default usePeppolNudge;
